import { XMarkIcon } from '@heroicons/react/24/solid';
import Link from 'next/link';
import { useState } from 'react';

import Button from '@/components/Button';

import styles from './styles.module.scss';
import { Props } from './types';

const MarketingTopbar = ({ marketingTopbarData }: Props) => {
  const [isVisible, setVisible] = useState(true);
  const handleClose = () => {
    setVisible(false);
  };

  if (
    !isVisible ||
    (isVisible &&
      (!marketingTopbarData?.TopbarText || !marketingTopbarData?.TopbarLink))
  ) {
    return null;
  }

  return (
    <div className={styles.marketingTopbarBg}>
      <div className={styles.marketingTopbarContainer}>
        <p className={styles.marketingText}>
          {marketingTopbarData?.TopbarText}
        </p>
        {marketingTopbarData?.TopbarLink && (
          <Link
            className={styles.marketingButton}
            href={marketingTopbarData?.TopbarLink}
          >
            Zobacz produkty
          </Link>
        )}
        <Button
          onClick={handleClose}
          variant="icon"
          className={styles.closeBtn}
        >
          <XMarkIcon />
        </Button>
      </div>
    </div>
  );
};

export default MarketingTopbar;
